import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {Link} from "react-router-dom";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

/**
 * Composant générique pour éditer une liste admin (QuoteState, TaskType, etc.)
 *
 * @param {Object} props
 * @param {string}          props.title        - Titre affiché au-dessus de la liste
 * @param {Array}           props.fields       - Les champs issus de useFieldArray
 * @param {Function}        props.handleSubmit - Handler de soumission
 * @param {Function}        props.register     - react-hook-form register
 * @param {Function}        props.onDelete     - Callback suppression d'un item
 * @param {Function}        props.onAdd        - Callback ajout d'un item
 * @param {string}          props.fieldName    - Nom du champ dans le formulaire (ex: "quoteState", "taskType")
 * @param {Function}        [props.renderItemExtras] - Render optionnel de contenu supplémentaire par item
 */
export default function AdminListEditor({
    title,
    fields,
    handleSubmit,
    register,
    onDelete,
    onAdd,
    fieldName,
    renderItemExtras,
}) {
    const {t} = usePolTranslation();

    return (
        <form className="form form__scrollable" onSubmit={handleSubmit}>
            <div className="col-12 col-md-4 field field-written">
                <h3>{title}</h3>
                <span className="field__border"/>
            </div>
            <div className="col-12 col-md-4 field field-written">
                <ul className="field__list">
                    {fields.map((input, index) => (
                        <li key={input.id} className="field__item custom-list" data-id={input.itemId}>
                            <input type="text"
                                   className="field__input"
                                   {...register(`${fieldName}.${index}.value`, input)}/>
                            <div className="field__item__delete">
                                <span onClick={onDelete(index)}>
                                    <PolIcon icon="trash"/>
                                </span>
                                {renderItemExtras && renderItemExtras(input, index)}
                            </div>
                        </li>
                    ))}
                </ul>
                <p className="field__list__add" onClick={onAdd}>
                    {t('ajouter_champ')}
                </p>
            </div>
            <div className="row align-items-center justify-content-end">
                <Link to="/administration/gestion_listes" className="col-12 col-md-auto form__back">
                    <PolIcon icon="chevron-circle-left" className="form__back__icon"/>
                    {t('retour')}
                </Link>
                <div className="col-12 col-md-auto form__submit">
                    <button className="btn btn-primary form__submit__btn" onClick={handleSubmit}>
                        {t('enregistrer')}
                    </button>
                </div>
            </div>
        </form>
    );
}
